<template>
  <div class="max-w-5xl mx-auto space-y-8">
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px" label-position="top">
      <!-- 成果归属 -->
      <AchievementTypeSection
        :achievement-type="formData.achievementType"
        :team-members="formData.teamMembers"
        @update:achievement-type="handleAchievementTypeChange"
        @update:team-members="handleTeamMembersChange"
      />

      <!-- 论文基本信息 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">论文基本信息</h3>
        <div class="space-y-4">
          <el-form-item label="论文名称" prop="name" required>
            <el-input
              v-model="formData.name"
              placeholder="请输入论文题目（不需加书名号）"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="是否通讯作者">
            <div class="flex gap-6">
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="1"
                    v-model="formData.is_correspond"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_correspond === '1'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_correspond === '1'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_correspond === '1' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  是
                </span>
              </label>
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="0"
                    v-model="formData.is_correspond"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_correspond === '0'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_correspond === '0'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_correspond === '0' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  否
                </span>
              </label>
            </div>
          </el-form-item>
        </div>
      </div>

      <!-- 论文类型与研究信息 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">论文类型与研究信息</h3>
        <div class="space-y-4">
          <el-form-item label="研究类别" prop="research_type" required>
            <el-select v-model="formData.research_type" placeholder="请选择研究类别" class="custom-select">
              <el-option value="1" label="基础研究" />
              <el-option value="2" label="实验与发展" />
              <el-option value="3" label="应用研究" />
            </el-select>
          </el-form-item>
          <el-form-item label="论文类别" prop="paper_type" required>
            <el-select v-model="formData.paper_type" placeholder="请选择论文类别" class="custom-select">
              <el-option value="1" label="科研" />
              <el-option value="2" label="教研" />
            </el-select>
          </el-form-item>
          <el-form-item label="学科门类" prop="subject" required>
            <el-input
              v-model="formData.subject"
              placeholder="请输入具体学科名称"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="资金资助情况">
            <el-input
              v-model="formData.funding_situation"
              placeholder="请输入资金资助情况"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="资金项目级别">
            <el-select v-model="formData.funding_level" placeholder="请选择资金项目级别" class="custom-select">
              <el-option value="国家级" label="国家级" />
              <el-option value="省部级" label="省部级" />
              <el-option value="市级" label="市级" />
              <el-option value="校级" label="校级" />
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!-- 发表信息 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">发表信息</h3>
        <div class="space-y-4">
          <el-form-item label="发表期刊">
            <el-input
              v-model="formData.journal"
              placeholder="请输入期刊名称（不需加书名号）"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="发表时间" prop="pub_time" required>
            <el-date-picker
              v-model="formData.pub_time"
              type="date"
              placeholder="选择发表时间"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              class="custom-input w-full"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="卷期号">
            <el-input
              v-model="formData.volume_issue"
              placeholder="如：第32卷第5期"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="页码范围">
            <el-input
              v-model="formData.page_range"
              placeholder="如：123-135"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="DOI号">
            <el-input
              v-model="formData.doi"
              placeholder="请输入DOI号"
              class="custom-input"
            />
          </el-form-item>
          <el-form-item label="收录情况">
            <el-select v-model="formData.status" placeholder="请选择收录情况" class="custom-select">
              <el-option value="SCI" label="SCI" />
              <el-option value="EI" label="EI" />
              <el-option value="CSSCI" label="CSSCI" />
              <el-option value="SSCI" label="SSCI" />
              <el-option value="北大核心" label="北大核心" />
              <el-option value="南大核心" label="南大核心" />
              <el-option value="中科院期刊" label="中科院期刊" />
              <el-option value="知网" label="知网" />
              <el-option value="维普" label="维普" />
              <el-option value="万方" label="万方" />
              <el-option value="其他" label="其他" />
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!-- 合作与跨学科信息 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">合作与跨学科信息</h3>
        <div class="space-y-4">
          <el-form-item label="是否与行业联合发表">
            <div class="flex gap-6">
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="1"
                    v-model="formData.is_industry"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_industry === '1'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_industry === '1'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_industry === '1' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  是
                </span>
              </label>
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="0"
                    v-model="formData.is_industry"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_industry === '0'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_industry === '0'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_industry === '0' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  否
                </span>
              </label>
            </div>
          </el-form-item>
          <el-form-item label="是否与地方联合发表">
            <div class="flex gap-6">
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="1"
                    v-model="formData.is_local"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_local === '1'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_local === '1'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_local === '1' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  是
                </span>
              </label>
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="0"
                    v-model="formData.is_local"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_local === '0'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_local === '0'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_local === '0' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  否
                </span>
              </label>
            </div>
          </el-form-item>
          <el-form-item label="是否与国际联合发表">
            <div class="flex gap-6">
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="1"
                    v-model="formData.is_international"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_international === '1'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_international === '1'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_international === '1' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  是
                </span>
              </label>
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="0"
                    v-model="formData.is_international"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_international === '0'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_international === '0'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_international === '0' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  否
                </span>
              </label>
            </div>
          </el-form-item>
          <el-form-item label="是否跨学科论文">
            <div class="flex gap-6">
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="1"
                    v-model="formData.is_cross"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_cross === '1'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_cross === '1'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_cross === '1' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  是
                </span>
              </label>
              <label class="flex items-center gap-3 cursor-pointer group">
                <div class="relative">
                  <input
                    type="radio"
                    value="0"
                    v-model="formData.is_cross"
                    class="sr-only"
                  />
                  <div :class="[
                    'w-5 h-5 rounded-full border-2 transition-all duration-200',
                    formData.is_cross === '0'
                      ? 'border-blue-600 bg-blue-600'
                      : 'border-gray-300 bg-white group-hover:border-blue-400'
                  ]">
                    <div v-if="formData.is_cross === '0'" class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"></div>
                  </div>
                </div>
                <span :class="[
                  'transition-colors duration-200',
                  formData.is_cross === '0' 
                    ? 'text-gray-900' 
                    : 'text-gray-600 group-hover:text-gray-800'
                ]">
                  否
                </span>
              </label>
            </div>
          </el-form-item>
        </div>
      </div>

      <!-- 其他信息 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">其他信息</h3>
        <div class="space-y-4">
          <el-form-item label="备注">
            <el-input
              v-model="formData.remark"
              type="textarea"
              :rows="4"
              placeholder="请写出团队成员"
              class="custom-input"
            />
          </el-form-item>
        </div>
      </div>

      <!-- 佐证材料 -->
      <div class="space-y-6">
        <h3 class="text-lg text-blue-600 border-b border-gray-200 pb-2 mt-8">佐证材料</h3>
        <FileUpload 
          ref="uploadRef"
          title="佐证材料上传" 
          description="请上传论文首页截图或发表证明"
          @success="onUploadSuccess"
          @change="onUploadChange"
        />
      </div>

      <!-- 提交按钮 -->
      <div class="flex justify-end space-x-4 pt-6 border-t border-gray-200">
        <el-button 
          @click="submitForm(true)"
          class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none border bg-white text-gray-900 hover:bg-gray-50 hover:text-gray-900 h-9 px-4 py-2"
        >
          保存草稿
        </el-button>
        <el-button 
          @click="submitForm(false)"
          class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none bg-blue-600 text-white hover:bg-blue-700 h-9 px-4 py-2 border-0"
        >
          提交
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from 'vue'
import FileUpload from '../common/FileUpload.vue'
import AchievementTypeSection from '../common/AchievementTypeSection.vue'
import { ElMessage } from 'element-plus'
import { savePaper, submitPaper, updatePaper, getPaperById } from '../../api/paper'
import { ensureValidTeamMembers } from '../../utils/teamMembers'
import { getMyInfo } from '../../api/user'
import { useRoute } from 'vue-router'

// 响应式数据
const formData = reactive({
  achievementType: '',
  isFirstAuthor: '',
  isFirstInUnit: '',
  teamMembers: [],
  name: '',
  is_correspond: '',
  research_type: '',
  paper_type: '',
  subject: '',
  funding_situation: '',
  funding_level: '',
  journal: '',
  pub_time: '',
  is_industry: '',
  is_local: '',
  is_international: '',
  is_cross: '',
  status: '',
  volume_issue: '',
  page_range: '',
  doi: '',
  remark: ''
})

const currentId = ref(null)
const loading = ref(false)
const evidenceMaterial = ref('')
const evidenceMaterialList = ref([])
const myInfo = ref(null)
const formRef = ref(null)
const uploadRef = ref(null)
const LAST_DRAFT_KEY = 'paper:lastDraftId'
const DRAFT_FORM_KEY = 'paper:draftForm'
const DRAFT_STATUS_KEY = 'paper:draftStatus'

const rules = reactive({
  name: [{ required: true, message: '请输入论文名称', trigger: 'blur' }],
  research_type: [{ required: true, message: '请选择研究类别', trigger: 'change' }],
  paper_type: [{ required: true, message: '请选择论文类别', trigger: 'change' }],
  subject: [
    { required: true, message: '请输入学科分类', trigger: 'blur' },
    { validator: subjectCategoryValidator, trigger: 'blur' }
  ],
  pub_time: [{ required: true, message: '请选择发表时间', trigger: 'change' }]
})

function subjectCategoryValidator(rule, value, callback) {
  const v = value == null ? '' : String(value).trim()
  if (!v) return callback()
  if (/^\d+$/.test(v)) return callback(new Error('请填写规范的学科分类中文名'))
  return callback()
}

// 处理成果归属变化
const handleAchievementTypeChange = (value) => {
  formData.achievementType = value
}


const handleTeamMembersChange = (members) => {
  formData.teamMembers = members
}

function formatDateTimePlain(input) {
  if (!input) return undefined
  const d = typeof input === 'string' ? new Date(input) : input
  if (!(d instanceof Date) || isNaN(d.getTime())) return undefined
  const pad = (n) => String(n).padStart(2, '0')
  const y = d.getFullYear()
  const m = pad(d.getMonth() + 1)
  const day = pad(d.getDate())
  const h = pad(d.getHours())
  const min = pad(d.getMinutes())
  const s = pad(d.getSeconds())
  return `${y}-${m}-${day} ${h}:${min}:${s}`
}

const IDENTITY_LABELS = { teacher: '教师', student: '学生', social: '社会人士' }
function toIdentityLabel(v) {
  const key = String(v || '')
  return IDENTITY_LABELS[key] ?? key
}

function normalizeAchievementType(v) {
  if (v === 'individual') return 1
  if (v === 'team') return 2
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

function denormalizeAchievementType(v) {
  if (v === 1 || v === '1') return 'individual'
  if (v === 2 || v === '2') return 'team'
  return ''
}

function normalizeMembers(members = []) {
  return (Array.isArray(members) ? members : []).map((m, idx) => ({
    position: m?.rank != null ? parseInt(m.rank, 10) || idx + 1 : idx + 1,
    name: m?.name || '',
    identity: toIdentityLabel(m?.identity),
    unit: m?.unit || ''
  }))
}

function sanitizeEvidenceMaterial(s) {
  const v = String(s || '')
  if (!v) return ''
  return v
    .split(',')
    .map(p => String(p || '').trim().replace(/`/g, ''))
    .filter(Boolean)
    .join(',')
}

function isValidUrl(u) {
  return /^https?:\/\/\S+$/.test(String(u || ''))
}

function filterValidEvidence(s) {
  const cleaned = sanitizeEvidenceMaterial(s)
  if (!cleaned) return ''
  const parts = cleaned.split(',').map(x => x.trim()).filter(Boolean)
  const valid = parts.filter(isValidUrl)
  return valid.join(',')
}

function valueToLabelResearchType(v) {
  if (v === '1') return '基础研究'
  if (v === '2') return '实验与发展'
  if (v === '3') return '应用研究'
  return String(v || '')
}

function valueToLabelPaperType(v) {
  if (v === '1') return '科研'
  if (v === '2') return '教研'
  return String(v || '')
}

function mapFormToApi(data, isDraft, id) {
  const publishTime = formatDateTimePlain(data.pub_time)
  const dto = {
    id: id != null ? Number(id) : undefined,
    achievementType: normalizeAchievementType(data.achievementType),
    paperName: data.name || '',
    isCorrespondingAuthor: parseInt(data.is_correspond || '0', 10) || 0,
    researchType: valueToLabelResearchType(data.research_type || ''),
    paperType: valueToLabelPaperType(data.paper_type || ''),
    subjectCategory: data.subject || '',
    fundingSupport: data.funding_situation || '',
    fundingProjectType: data.funding_level || '',
    publishedJournal: data.journal || '',
    volumeIssue: data.volume_issue || '',
    pageRange: data.page_range || '',
    doi: data.doi || '',
    inclusionStatus: data.status || '',
    isIndustryJointPublish: parseInt(data.is_industry || '0', 10) || 0,
    isLocalJointPublish: parseInt(data.is_local || '0', 10) || 0,
    isInternationalJointPublish: parseInt(data.is_international || '0', 10) || 0,
    isInterdisciplinaryPaper: parseInt(data.is_cross || '0', 10) || 0,
    remark: data.remark || '',
    evidenceMaterial: filterValidEvidence(evidenceMaterial.value || ''),
    status: isDraft ? 1 : 2,
    memberList: normalizeMembers(data.teamMembers)
  }
  if (publishTime) dto.publishTime = publishTime
  if (dto.achievementType === 1 && (!Array.isArray(dto.memberList) || dto.memberList.length === 0)) {
    const info = myInfo.value || {}
    const name = String(info?.name || '')
    const identity = String(info?.role || '教师')
    const unit = String(info?.college || '')
    dto.memberList = name || unit ? [{ position: 1, name, identity, unit }] : []
  }
  return dto
}

function mapApiToForm(dto = {}) {
  formData.achievementType = denormalizeAchievementType(dto.achievementType)
  formData.teamMembers = Array.isArray(dto.memberList)
    ? dto.memberList.map((m, i) => ({
        id: `${Date.now()}_${i}`,
        name: String(m?.name || ''),
        identity: String(m?.identity || ''),
        unit: String(m?.unit || ''),
        rank: Number(m?.position ?? i + 1) || i + 1
      }))
    : []

  formData.name = dto.paperName ?? ''
  formData.is_correspond = String(dto.isCorrespondingAuthor ?? '')
  formData.research_type = dto.researchType ?? ''
  formData.paper_type = dto.paperType ?? ''
  formData.subject = dto.subjectCategory ?? ''
  formData.funding_situation = dto.fundingSupport ?? ''
  formData.funding_level = dto.fundingProjectType ?? ''
  formData.journal = dto.publishedJournal ?? ''
  formData.pub_time = dto.publishTime ? toDateYMD(dto.publishTime) : ''
  formData.volume_issue = dto.volumeIssue ?? ''
  formData.page_range = dto.pageRange ?? ''
  formData.doi = dto.doi ?? ''
  formData.status = dto.inclusionStatus ?? ''
  formData.is_industry = String(dto.isIndustryJointPublish ?? '')
  formData.is_local = String(dto.isLocalJointPublish ?? '')
  formData.is_international = String(dto.isInternationalJointPublish ?? '')
  formData.is_cross = String(dto.isInterdisciplinaryPaper ?? '')
  formData.remark = dto.remark ?? ''

  const em = dto.evidenceMaterial || ''
  evidenceMaterial.value = em
  evidenceMaterialList.value = em ? String(em).split(',').filter(Boolean) : []
}

function toDateYMD(input) {
  if (!input) return ''
  const d = typeof input === 'string' ? new Date(input) : input
  if (!(d instanceof Date) || isNaN(d.getTime())) return ''
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

// 如需编辑回显，可实现 mapApiToForm(dto) 并在页面加载时调用

function onUploadSuccess({ url }) {
  if (url && !evidenceMaterialList.value.includes(url)) {
    evidenceMaterialList.value.push(url)
    evidenceMaterial.value = evidenceMaterialList.value.join(',')
  }
}

function onUploadChange({ url, type }) {
  if (type === 'remove') {
    evidenceMaterialList.value = evidenceMaterialList.value.filter(u => u !== url)
    evidenceMaterial.value = evidenceMaterialList.value.join(',')
  }
}

// 提交表单
const submitForm = async (isDraft = false) => {
  try {
    loading.value = true
    const ok = await (formRef.value?.validate?.() ?? Promise.resolve(true)).catch(() => false)
    if (!ok) {
      ElMessage.error('请完善所有必填项')
      loading.value = false
      return
    }
    if (!formData.achievementType) {
      ElMessage.error('请选择成果归属')
      loading.value = false
      return
    }
    if (formData.achievementType === 'team') {
      const { ok: membersOk, message } = ensureValidTeamMembers(formData.achievementType, formData.teamMembers)
      if (!membersOk) {
        ElMessage.error(message || '团队成员信息未填写完整')
        loading.value = false
        return
      }
    }
    const base = mapFormToApi(formData, isDraft, currentId.value)
    if (!currentId.value) {
      if (isDraft) {
        const resp = await savePaper(base)
        const id = resp?.id ?? resp?.data?.id ?? resp?.data?.data?.id
        if (id) currentId.value = id
      } else {
        const resp = await submitPaper(base)
        const id = resp?.id ?? resp?.data?.id ?? resp?.data?.data?.id
        if (id) currentId.value = id
      }
    } else {
      const updateDto = { ...base, id: Number(currentId.value), status: isDraft ? 1 : 2 }
      await updatePaper(updateDto)
    }
    if (isDraft) {
      if (!currentId.value) {
        try {
          localStorage.setItem(LAST_DRAFT_KEY, String(currentId.value))
          localStorage.setItem(DRAFT_STATUS_KEY, '1')
          const snapshot = {
            form: { ...formData },
            evidenceMaterial: evidenceMaterial.value || '',
            evidenceMaterialList: Array.isArray(evidenceMaterialList.value) ? [...evidenceMaterialList.value] : [],
            currentId: currentId.value || null
          }
          localStorage.setItem(DRAFT_FORM_KEY, JSON.stringify(snapshot))
        } catch (e) { console.warn(e) }
      }
    } else {
      try { await nextTick(); formRef.value?.clearValidate?.(); formRef.value?.resetFields?.() } catch (e) { console.warn(e) }
      currentId.value = null
      try { localStorage.removeItem(LAST_DRAFT_KEY) } catch (e) { console.warn(e) }
      try { localStorage.removeItem(DRAFT_FORM_KEY) } catch (e) { console.warn(e) }
      try { localStorage.removeItem(DRAFT_STATUS_KEY) } catch (e) { console.warn(e) }
      try { resetForm() } catch (e) { console.warn(e) }
    }
    ElMessage.success(isDraft ? '草稿保存成功' : '提交成功')
  } catch (err) {
    console.error(err)
    ElMessage.error(isDraft ? '草稿保存失败' : '提交失败')
  } finally {
    loading.value = false
  }
}

const route = useRoute()
onMounted(async () => {
  try {
    const info = await getMyInfo()
    const data = info?.data ?? info
    myInfo.value = data
  } catch (e) { console.warn(e) }
  const rid = route.query?.detailId || route.query?.id  // ← 优先用 detailId
  if (rid) {
    try {
      currentId.value = rid
      const dto = await getPaperById(rid)
      mapApiToForm(dto?.data ?? dto)
    } catch (e) { console.warn(e) }
  } else {
    try {
      const draftFlag = localStorage.getItem(DRAFT_STATUS_KEY)
      if (draftFlag === '1') {
        const raw = localStorage.getItem(DRAFT_FORM_KEY)
        if (raw) {
          try {
            const snapshot = JSON.parse(raw)
            const f = snapshot?.form || {}
            Object.assign(formData, f)
            evidenceMaterial.value = snapshot?.evidenceMaterial || ''
            evidenceMaterialList.value = Array.isArray(snapshot?.evidenceMaterialList) ? [...snapshot.evidenceMaterialList] : []
            const id = snapshot?.currentId || localStorage.getItem(LAST_DRAFT_KEY)
            if (id) currentId.value = id
          } catch (e) { console.warn(e) }
        }
      }
    } catch (e) { console.warn(e) }
  }
})
const resetForm = () => {
  Object.assign(formData, {
    achievementType: '',
    isFirstAuthor: '',
    isFirstInUnit: '',
    teamMembers: [],
    name: '',
    research_type: '',
    paper_type: '',
    subject: '',
    funding_situation: '',
    funding_level: '',
    journal: '',
    volume_issue: '',
    page_range: '',
    doi: '',
    status: '',
    is_industry: '',
    is_local: '',
    is_international: '',
    is_cross: '',
    pub_time: '',
    remark: ''
  })
  evidenceMaterial.value = ''
  evidenceMaterialList.value = []
  currentId.value = null
  try { uploadRef.value?.clear?.() } catch (e) { console.warn(e) }
}
</script>

<style scoped>
/* 使用 Tailwind CSS 样式 */

/* 自定义输入框样式 */
.custom-input :deep(.el-input__wrapper) {
  background-color: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
}

.custom-input :deep(.el-input__wrapper:hover) {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.custom-input :deep(.el-input__wrapper.is-focus) {
  background-color: #ffffff;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.custom-input :deep(.el-input__inner) {
  color: #111827;
}

.custom-input :deep(.el-input__inner::placeholder) {
  color: #9ca3af;
}

.custom-input :deep(.el-textarea__inner) {
  background-color: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  color: #111827;
}

.custom-input :deep(.el-textarea__inner:hover) {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.custom-input :deep(.el-textarea__inner:focus) {
  background-color: #ffffff;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.custom-input :deep(.el-textarea__inner::placeholder) {
  color: #9ca3af;
}

/* 自定义选择框样式 */
.custom-select :deep(.el-select__wrapper) {
  background-color: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
}

.custom-select :deep(.el-select__wrapper:hover) {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.custom-select :deep(.el-select__wrapper.is-focused) {
  background-color: #ffffff;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.custom-select :deep(.el-select__placeholder) {
  color: #9ca3af;
}

.custom-select :deep(.el-select__input-text) {
  color: #111827;
}

/* 自定义选择框下拉菜单样式 */
.custom-select-dropdown {
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.custom-select-dropdown .el-select-dropdown__item {
  color: #111827;
  transition: all 0.2s ease-in-out;
}

.custom-select-dropdown .el-select-dropdown__item:hover {
  background-color: #f3f4f6;
}

.custom-select-dropdown .el-select-dropdown__item.is-selected {
  background-color: #3b82f6;
  color: #ffffff;
}
</style>
